<template>

  <v-layout>
    <v-checkbox v-for="(item, index) in items" :key="index" v-model="selectedItems" :label="item" :value="item"></v-checkbox>
  </v-layout>

</template>

<script>

export default {
  name: 'VideoTypesSelector',
  props: ['currentTypes'],
  data () {
    return {
      items: ['summary', 'point', 'wow', 'fail'],
      selectedItems: []
    }
  },
  mounted () {
    if (this.currentTypes) {
      this.selectedItems = this.currentTypes
    } else {
      this.clear()
    }
  },
  methods: {
    clear () {
      this.selectedItems = []
    }
  },
  watch: {
    'selectedItems' () {
      this.$emit('typesSelected', this.selectedItems)
    },
    'currentTypes' () {
      if (this.currentTypes) {
        this.selectedItems = this.currentTypes
      } else {
        this.clear()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/VideoTypesSelector.vue